import { render, staticRenderFns } from "./DownloadModule.vue?vue&type=template&id=73201a8f&scoped=true&"
import script from "./DownloadModule.vue?vue&type=script&lang=js&"
export * from "./DownloadModule.vue?vue&type=script&lang=js&"
import style0 from "./DownloadModule.vue?vue&type=style&index=0&id=73201a8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73201a8f",
  null
  
)

export default component.exports